<template>
  <v-main >  
    <v-layout text-center>
      <v-container class="containerGallery">
      <div v-if="groupedImages" class="fullscreen pb-10">
        <div v-for="(item,key) in groupedImages" :key="key" class="m-auto pt-5 pb-12 px-3 px-sm-4" style="max-width:1200px">
          <h1 class="px-5 py-4 white--text text-left" :style="{'color':theme.backgroundColor + '!important'}">{{item.title}}</h1>
          <v-sheet
            elevation="0"
            width="100%"
            class="pa-2 pa-sm-8"
            rounded="lg"
            :color="theme.backgroundColor"
          >
          <EspGallery style="text-align:center" :images="item.images" :alias="(key+1)" :aspectRatio="1"/>
          </v-sheet>
        </div>
      </div>
      </v-container>
    </v-layout>
  </v-main>
</template>

<script>
import {layoutMixin} from '@/utils/layout-mixin'
import {settingsMixin} from '@/utils/settings-mixin'
import CONFIG from '@/constants/config.js'
import EspGallery from '@/components/ui/EspGallery.vue'
export default {
  mixins: [layoutMixin,settingsMixin],
  components:{
    EspGallery
  },
  data(){
    return {
      groupedImages:null,
      index: null
    }
  },
  watch: {
    userLanguage: {
      handler() {
        this.loadContent();
      },
      immediate: true
    }
  },
  computed: {

  },
  methods: {
    loadContent(){
      const url=`${CONFIG.FEATURE_GALLERY.url}_${this.userLanguage}.json`;
      this.axios.get(url).then(response=>{
        if(response){
          this.groupedImages=response.data;
        }
      })
    }
  },
  
}
</script>

<style scoped>
.containerGallery{

}
.fullscreen{
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  overflow: auto;
}
</style>
